import React from "react";
import { useLoaderData } from "react-router-dom";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import "./Statistics.css";

const Statistics = () => {
  //const data = [{ name: "Page A", uv: 400, pv: 2400, amt: 2400 }];
  const loadData = useLoaderData();
  const data = loadData.data;

  let width;

  if (window.screen.width < 700) {
    width = 350;
  } else {
    width = 600;
  }

  return (
    <div>
      <h3>Statistics Result</h3>
      <div className="mt-5">
        <LineChart
          width={width}
          height={300}
          data={data}
          margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
        >
          <Line type="monotone" dataKey="total" stroke="#8884d8" />
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
        </LineChart>
      </div>
    </div>
  );
};

export default Statistics;
